export const SESSION_STORAGE_KEYS = {
  SESSION_ID: 'koalaSessionId',
  SESSION_START: 'koalaSessionStartTime',
  KOALA_ORDER: 'koalaOrder',
  ORDER_START: 'cooOrderStart',
};
